import React from 'react';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import AddDataPicker from 'subscriptions/AddDataPicker/sprint';
import DataRemaining from 'subscriptions/DataRemaining/sprint';
import * as routes from 'app/routes';
import styles from './AddData.module.css';
import add_data from 'common/img/add_data.svg';
import Back from 'common/Back';

export const AddDataScreen = ({ subId }) => {
  return (
    <div className={styles.AddData}>
      <SubscriptionSwitcher
        sprintSubId={subId}
        sprintRoute={routes.sprintAddData}
        attRoute={routes.attAddData}
        quickRoute={routes.quickSubscription}
      />
      <div className={styles.Back}>
        <Back to={routes.sprintSubscription(subId)} />
      </div>
      <h1>
        Add Data
        <img src={add_data} alt="" />
      </h1>
      <DataRemaining subId={subId} />
      <AddDataPicker sprintSubId={subId} />
    </div>
  )
}

export default AddDataScreen;
